import {Box} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import {useVuplex} from '../../hooks/useVuplex';
import {sendActionPanelClose} from '../../vuplex';
import MinimapClickActionToast from './Minimap/Toast/MinimapClickActionToast';
import PanoNoneForLocationToast from './Minimap/Toast/PanoNoneForLocationToast';
import PageTitle from './PageTitle';
import WikiActionPanelContent from './Minimap/Toast/WikiActionPanelContent';
import LocationSaveToast from './Minimap/Toast/LocationSaveToast';
import {useSelector} from 'react-redux';
import {APIProvider} from '@vis.gl/react-google-maps';

const initialProps = {
  actionPanelTool: null,
  address: null,
  altitude: null,
  isAltitudeDefined: null,
  latitude: null,
  longitude: null,
  placeId: null,
  suggestedLabel: null,
  wikipedia: null,
  zoomLevel: null,
};

const ActionPanel = ({}) => {
  const [props, setProps] = useState(null);

  useEffect(() => {
    document.body.style.background = 'none';
  }, []);

  useVuplex({
    actionPanel: (jsonProps) => {
      setProps(JSON.parse(jsonProps)); // this is JSON data from an actionPanelRequest originating in another web view
    },
    actionPanelClose: () => {
      setProps(initialProps);
    },
    laserAction: (data) => {
      setProps(data);
    },
    locationSave: (data) => {
      setProps(data);
    },
  });

  const googleApiKey = useSelector(s => s.inApp.googleApiKey);

  if (!googleApiKey) return null;
  if (!props) return null;
  console.log('ActionPanel props', props);

  const {actionPanelTool} = props;

  return googleApiKey && (
    <APIProvider apiKey={googleApiKey}>
      <PageTitle title="ActionPanel - Wooorld"/>
      <Box
        h="100vh"
        w="100vw"
      >
        <LocationSaveToast
          address={props.address}
          altitude={props.altitude}
          isAltitudeDefined={props.isAltitudeDefined}
          isDisabled={actionPanelTool !== 'locationSaveToast'}
          latitude={props.latitude}
          longitude={props.longitude}
          onClose={sendActionPanelClose}
          suggestedLabel={props.suggestedLabel}
          zoomLevel={props.zoomLevel}
        />

        <MinimapClickActionToast
          brushStroke={props.timeToDeletion && props}
          isAltitudeDefined={props.isAltitudeDefined}
          isDisabled={actionPanelTool !== 'minimapClickActionToast'}
          altitude={props.altitude}
          latitude={props.latitude}
          longitude={props.longitude}
          placeId={props.placeId}
          zoom={props.zoom}
          onClose={sendActionPanelClose}
          skipReverseGeocode={props.skipReverseGeocode}
        />

        <PanoNoneForLocationToast
          onClose={sendActionPanelClose}
          onOpen={() => {
            setProps({
              ...initialProps,
              actionPanelTool: 'panoNoneForLocationToast',
            });
          }}
        />

        {actionPanelTool === 'wikiActionPanelContent' && (
          <WikiActionPanelContent onClose={sendActionPanelClose} wikipedia={props.wikipedia}/>
        )}
      </Box>
    </APIProvider>
  );


};

export default ActionPanel;
